
import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios"
import { useQuery } from "@tanstack/react-query";
import { User } from "@types";
import { getKeycloakRealm } from "@/components/helpers";

export const useGetChallengeUsers = () => {

    const axios = useAxios();
    const {t} = useTranslation();
    const realm = getKeycloakRealm;

    const fetchUsers = async () => {
        try {
            const { data } = await axios.get<{items: User[]}>("/api/UsersForChallenges");
            return data;
        } catch (error) {
            throw new Error(t("messages.error.getUsers"));
        }
    }

    return useQuery({
        queryKey: ["challengeUsers", realm],
        queryFn: fetchUsers,
        staleTime: 0,
        gcTime: 5 * 60 * 1000,
        refetchOnMount: 'always',
        refetchOnWindowFocus: true,
    })
}